import styled from "styled-components";
import css from "@styled-system/css";

import Card from "../Card/Card";
import Typography from "../Typography/Typography";
import Box from "../Box/Box";
import Icon from "../Icon/Icon";
import { LayoutProps } from "styled-system";

const StyledCard = styled(Card)`
  ${css({
    p: 6,
    m: 0,
  })}
`;

interface CardContent {
  headline: string;
  description: string;
  moreInfo?: {
    label: string;
    isVisible: boolean;
  };
  width: LayoutProps["width"];
  height: LayoutProps["height"];
}

export default function WideCardWithNoImage({
  headline,
  description,
  width = { _: 300, tablet: 460 },
  height = "100%",
}: CardContent) {
  return (
    <StyledCard
      width={width}
      height={height}
      aria-label="wide card with no image"
      variant="hoverable"
    >
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h5" textAlign="left" color="text-color" m={0}>
          {headline}
        </Typography>
        <Icon
          name="arrow-right"
          weight="regular"
          width={20}
          height={20}
          m={0}
          ml={6}
        />
      </Box>
      <Typography
        variant="body"
        color="lighter-text-color"
        textAlign="left"
        mt={2}
        pr={{ _: 1, tablet: "72px" }}
        mb={0}
        css={`
          line-height: 1.36;
          min-height: 57px;
        `}
      >
        {description}
      </Typography>
    </StyledCard>
  );
}
